export default (value) => {
    const m = /\$([-a-z0-9A-Z._]+)(?::([^$]*))?\$/.exec(value);
    return m && m[2] ? m[2].split(/,/) : null;
};
//# sourceMappingURL=getDesigntimePropertyAsArray.js.map